<!-- Modal (Notas Fiscais (Sintéticas)) -->

<ng-template #notasFiscaisSinteticas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-notas-fiscais-sinteticas"><b>Notas fiscais e duplicatas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-pedido-modal-notas-fiscais [notasFiscais]="notasFiscais"></app-pedido-modal-notas-fiscais>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Check-out Pendente) -->

<ng-template #comCheckOutPendente let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-com-checkout-pendente"><b>Check-out</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="text-center">
      <h5><b>Existe check-out pendente! Deseja finalizá-lo?</b></h5>
    </div>

    @if (visitaCheckOutPendente != null) {
      <div class="mt-3">
        <div><b>Vendedor:</b> {{ visitaCheckOutPendente.fullname }}</div>
        <div><b>Início:</b> {{ visitaCheckOutPendente.check_in | date: 'dd/MM/yyyy HH:mm:ss' }}</div>
        <div><b>Tempo aberto:</b> {{ visitaCheckOutPendente.duracao || 0 }} min</div>
        <div><b>Ligação:</b> {{ visitaCheckOutPendente.id_call_center_ligacao }}</div>
      </div>
    }
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Nao')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Sim')">Finalizar</button>
  </div>
</ng-template>

<!-- Modal (Nova Ligação) -->

<ng-template #novaLigacao let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-nova-ligacao"><b>Nova (Ligação)</b></h3>
  </div>

  <div class="modal-body">
    <form [formGroup]="formFiltroCliente" (ngSubmit)="filtrarCliente()">
      @if (clienteSelecionadoExterno == '') {
        <div class="form-row">
          <div class="form-group col-sm-2">
            <label class="text-secondary"><b>Filtrar Cliente por:</b></label>
            <select class="form-control form-control-sm" name="filtrar_cliente_por" formControlName="filtro" (change)="alterarFiltroCliente($event.target.value)">
              @for (opcao of filtroClientes; track opcao) {
                <option [value]="opcao.valor" [selected]="opcao.valor == fc.filtro.value">{{ opcao.texto }}</option>
              }
            </select>
          </div>
          <!-- Código -->
          @if (fc.filtro.value == 0) {
            <div class="form-group col-sm-2">
              <label class="text-secondary"><b>Código:</b></label>
              <input class="form-control form-control-sm" type="text" name="cliente_filtrar_codigo" [ngClass]="{ 'is-invalid': enviadoCliente && fc.codigo.errors?.required }" formControlName="codigo" />
              @if (enviadoCliente && fc.codigo.errors?.required) {
                <div class="erro pt-1">Código em branco!</div>
              }
            </div>
          }
          <!-- CNPJ/CPF -->
          @if (fc.filtro.value == 1) {
            <div class="form-group col-sm-2">
              <label class="text-secondary"><b>CNPJ/CPF:</b></label>
              <input class="form-control form-control-sm" type="text" name="cliente_filtrar_cnpj_cpf" [ngClass]="{ 'is-invalid': enviadoCliente && fc.cnpj_cpf.errors?.required }" formControlName="cnpj_cpf" />
              @if (enviadoCliente && fc.cnpj_cpf.errors?.required) {
                <div class="erro pt-1">CNPJ/CPF em branco!</div>
              }
            </div>
          }
          <!-- Nome Fantasia -->
          @if (fc.filtro.value == 2) {
            <div class="form-group col-sm-4">
              <label class="text-secondary"><b>Nome Fantasia:</b></label>
              <input class="form-control form-control-sm" type="text" name="cliente_filtrar_nome_fantasia" [ngClass]="{ 'is-invalid': enviadoCliente && (fc.nome_fantasia.errors?.required || fc.nome_fantasia.errors?.minlength) }" formControlName="nome_fantasia" />
              @if (enviadoCliente && fc.nome_fantasia.errors?.required) {
                <div class="erro pt-1">Nome Fantasia em branco!</div>
              }
              @if (enviadoCliente && fc.nome_fantasia.errors?.minlength) {
                <div class="erro pt-1">Mínimo de 3 caracteres!</div>
              }
            </div>
          }
          <!-- Razão Social -->
          @if (fc.filtro.value == 3) {
            <div class="form-group col-sm-4">
              <label class="text-secondary"><b>Razão Social:</b></label>
              <input class="form-control form-control-sm" type="text" name="cliente_filtrar_razao_social" [ngClass]="{ 'is-invalid': enviadoCliente && (fc.razao_social.errors?.required || fc.razao_social.errors?.minlength) }" formControlName="razao_social" />
              @if (enviadoCliente && fc.razao_social.errors?.required) {
                <div class="erro pt-1">Razão Social em branco!</div>
              }
              @if (enviadoCliente && fc.razao_social.errors?.minlength) {
                <div class="erro pt-1">Mínimo de 3 caracteres!</div>
              }
            </div>
          }
          <div class="col-sm-3">
            <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>
            @if (filtrandoCliente) {
              <button class="btn btn-secondary btn_filtro" type="button" (click)="alterarFiltroCliente(null)">Cancelar</button>
            }
          </div>
        </div>
        <hr class="mt-2 mb-2" />
      }

      @if (filtrandoCliente) {
        <div [@esvanecerDesvanecer]="'in'">
          <div class="filtrar_cliente p-1">
            <div class="table-responsive">
              <cdk-virtual-scroll-viewport class="filtrar_cliente_tabela" [itemSize]="10">
                <table class="table table-sm table-hover">
                  <thead>
                    <tr>
                      <th class="text-center">Código</th>
                      <th class="tabela_borda">Cliente</th>
                      <th class="tabela_borda">Vendedor</th>
                      <th class="tabela_borda text-center">CNPJ/CPF</th>
                      <th class="tabela_borda">Endereço</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *cdkVirtualFor="let cliente of clientes; templateCacheSize: 0;">
                      <tr class="filtrar_cliente_acao" (click)="selecionarClienteFiltrado(cliente.codigo_no_erp_do_cliente)">
                        <td class="text-center">{{ cliente.codigo_no_erp_do_cliente }}</td>
                        <td class="tabela_borda">{{ cliente.name }}</td>
                        <td class="tabela_borda">{{ cliente.fullname }}</td>
                        <td class="tabela_borda text-center">{{ cliente.client_document }}</td>
                        <td class="tabela_borda">{{ cliente.endereco_completo }}</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </cdk-virtual-scroll-viewport>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
        </div>
      }

      <div class="form-row">
        <div class="form-group col-sm-2">
          <label><b>Código:</b></label>

          <input class="form-control form-control-sm" type="text" name="cliente_codigo" [value]="clienteSelecionado == null ? '' : clienteSelecionado.codigo_no_erp_do_cliente" [ngClass]="{ 'is-invalid': clienteInvalido }" disabled />
        </div>

        <div class="form-group col-sm-10">
          <label><b>Cliente:</b></label>

          <input class="form-control form-control-sm" type="text" name="cliente_razao_social" [value]="clienteSelecionado == null ? '' : clienteSelecionado.name" [ngClass]="{ 'is-invalid': clienteInvalido }" disabled />

          @if (clienteInvalido) {
            <div class="erro pt-1">Cliente em branco!</div>
          }
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-sm-8">
          <label><b>Endereço:</b></label>

          <input class="form-control form-control-sm" type="text" name="cliente_endereco" [value]="clienteSelecionado == null ? '' : clienteSelecionado.endereco_completo" [ngClass]="{ 'is-invalid': clienteInvalido }" disabled />
        </div>

        <div class="form-group col-sm-2">
          <label><b>CNPJ/CPF:</b></label>

          <input class="form-control form-control-sm" type="text" name="cliente_cnpj_cpf" [value]="clienteSelecionado == null ? '' : clienteSelecionado.client_document" [ngClass]="{ 'is-invalid': clienteInvalido }" disabled />
        </div>

        <div class="form-group col-sm-2">
          <label>
            <b>Notas Fiscais:</b>

            @if (clienteSelecionado != null && clienteSelecionado.client_document != null && clienteSelecionado.client_document != '') {
              <i class="fa fa-info label_acao ml-2" placement="top" ngbTooltip="Notas Fiscais" (click)="modalNotasFiscaisSinteticas(notasFiscaisSinteticas, clienteSelecionado.client_document)"></i>
              &nbsp;
            }
          </label>

          <input class="form-control form-control-sm" type="text" name="cliente_status" [value]="clienteSelecionado == null ? '' : clienteSelecionado.status_financeiro != null ? 'INADIMPLENTE' : '-'" [ngClass]="{ 'is-invalid': clienteInvalido }" disabled />
        </div>
      </div>

      <hr class="mt-2 mb-2" />

      <div class="form-row">
        <div class="form-group col-sm-12">
          <label><b>Tipo:</b></label>

          <select class="form-control form-control-sm" name="tipo" #tipo (change)="selecionarTipo(tipo.value)">
            @for (opcao of tipos; track opcao) {
              <option [value]="opcao.id" [selected]="tipoSelecionado != null ? opcao.id == tipoSelecionado.id : null">{{ opcao.name }}</option>
            }
          </select>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Iniciar')">Iniciar</button>
  </div>
</ng-template>
